export default __webpack_public_path__ + "static/media/no-task.ad854637.svg";